import { classNames } from '../../utils';

export interface Tab {
  id: string;
  name: string;
  current: boolean;
}

interface Props {
  tabs: Tab[];
  onTabClick: (id: string, index: number) => void;
  className?: string;
  fullWidth?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export default function Tabs({
  tabs,
  onTabClick,
  className,
  fullWidth,
  size = 'md',
}: Props) {
  return (
    <div
      className={classNames('flex w-full border-b border-gray-200', className)}
    >
      <nav
        className={classNames(
          'no-scrollbar -mb-px flex w-full overflow-x-scroll border-b border-gray-200',
          fullWidth ? 'w-full' : 'w-auto space-x-8',
        )}
        aria-label="Tabs"
      >
        {tabs.map((tab, i) => (
          <button
            key={tab.name}
            onClick={() => onTabClick(tab.id, i)}
            className={classNames(
              tab.current
                ? 'border-indigo-500 text-indigo-600'
                : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
              'whitespace-nowrap border-b-2 px-1 text-sm font-medium',
              fullWidth ? 'flex-1' : '',
              size === 'sm'
                ? 'min-h-[36px] py-2'
                : size === 'md'
                  ? 'min-h-[42px] py-3'
                  : 'min-h-[54px] py-4',
            )}
            aria-current={tab.current ? 'page' : undefined}
            style={{ fontWeight: 500 }}
          >
            {tab.name}
          </button>
        ))}
      </nav>
    </div>
  );
}
